import React from "react";
import bigSizedSofa from "../assets/img/big-sized-sofa.png";
import bigSizedWallet from '../assets/img/big-sized-wallet.png';
// import sofaIjo from '../assets/img/sofa-ijo/sofa-ijo.png';
// import dompetCoklat from '../assets/img/dompet-coklat/dompet-coklat.png';
const BigCart = () => {
  return (
    <div className="container">
      <div className="big-cart">
        <div className="big-cart-wrapper" style={{ marginBottom: '40px' }}>
          <div className="img-wrapper">
            <img src={bigSizedSofa} alt='sofa' className="big-cart-image" />
          </div>
          <div className="text-wrapper">
            <p className="header-text">Perabotan Rumah Tangga</p>
            <p className="child-text">Percantik rumah anda dengan sofa nyaman dan murah.</p>
            <p className="box-text">Belanja Perabot Rumah Tangga</p>
          </div>
        </div>

        <div className="big-cart-wrapper rtl">
          <div className="img-wrapper">
            <img src={bigSizedWallet} alt='dompet' className="big-cart-image" />
          </div>
          <div className="text-wrapper">
            <p className="header-text">Aksesoris Pria</p>
            <p className="child-text">Tampil lebih keren dengan dompet kulit awet dan stylish.</p>
            <p className="box-text">Belanja Aksesoris Pria</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BigCart;
